import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App.tsx";
import "./index.css";
import { initTelemetry } from "./lib/telemetry";
import { initSentry } from "./lib/sentry";

// Initialize error tracking and telemetry (non-blocking)
initSentry();
initTelemetry();

// Theme now defaults to light (langdock-clean). One-time migration resets the
// old auto-persisted "dark" default so existing sessions pick up light; explicit
// toggles thereafter are respected.
if (!localStorage.getItem("theme-migrated-light")) {
  localStorage.setItem("theme", "light");
  localStorage.setItem("theme-migrated-light", "1");
}
const storedTheme = localStorage.getItem("theme");
document.documentElement.classList.toggle("dark", storedTheme === "dark");

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error("Missing VITE_CLERK_PUBLISHABLE_KEY environment variable");
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById("root")!).render(
  <ClerkProvider
    publishableKey={CLERK_PUBLISHABLE_KEY}
    taskUrls={{ 'setup-mfa': '/session-tasks/setup-mfa' }}
  >
    <App />
  </ClerkProvider>
);
